import React from 'react';
import { DataGrid } from '../common/datagrid/ResponsiveDataGrid';
import CustomToolbar from '../common/datagrid/CustomToolbar';
import CustomLoadingOverlay from '../common/datagrid/CustomLoadingOverlay';

const TaxbillList = ({
  dashboard,
  apiRef,
  columns,
  rows,
  error,
  loading,
  handleRowEditStart,
  handleRowEditStop,
  handleCellFocusOut,
  handleCellEditable,
  sortModel,
  onSortModelChange,
  columnVisibilityModel
}) => {
  const [pageSize, setPageSize] = React.useState(20);
  const [height, setHeight] = React.useState('calc(100vh - 280px)');

  React.useEffect(() => {
    if (dashboard) {
      setHeight('350px');
    }
  }, [dashboard]);

  return (
    <div style={{ display: 'flex', height: height }}>
      <div style={{ flexGrow: 1 }}>
        <DataGrid
          apiRef={apiRef}
          rows={rows ? rows : []}
          columns={columns}
          components={{
            Toolbar: CustomToolbar,
            LoadingOverlay: CustomLoadingOverlay,
          }}
          componentsProps={{
            toolbar: { fileName: '계산서_리스트' },
          }}
          isCellEditable={handleCellEditable}
          loading={loading}
          editMode="row"
          sortModel={sortModel}
          onSortModelChange={onSortModelChange}
          onRowEditStart={handleRowEditStart}
          onRowEditStop={handleRowEditStop}
          onCellFocusOut={handleCellFocusOut}
          initialState={{
            pinnedColumns: {
              left: ['invNo', 'partnerNm', 'cstNm'],
              right: ['actions'],
            },
          }}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[5, 10, 20, 50, 100]}
          pagination
          columnVisibilityModel={columnVisibilityModel? columnVisibilityModel: []}
        />
      </div>
    </div>
  );
};

export default TaxbillList;
